import { useState, useEffect, useContext } from "react";
import { UserContext } from "UserContext";

interface userHasAdminAccessToCompanyPropTypes {
  company_id?: string;
  company_name?: string;
}

const useUserHasAdminAccessToCompany = ({
  company_id,
  company_name,
}: userHasAdminAccessToCompanyPropTypes): string | boolean => {
  // @ts-ignore
  const [userContext, dispatchUserContext] = useContext(UserContext);
  const [isUserAdminOfCompany, setIsUserAdminOfCompany] = useState<
    string | boolean
  >("loading");

  useEffect(() => {
    if (!company_id && !company_name) {
      return;
    }

    if (!userContext.user) {
      return;
    }

    if (!userContext.companiesUserHasAdminAccessTo) {
      return;
    }

    if (userContext.user.is_super_admin === true) {
      setIsUserAdminOfCompany(true);
      return;
    }

    for (let i in userContext.companiesUserHasAdminAccessTo) {
      let company = userContext.companiesUserHasAdminAccessTo[i];

      if (company_id !== undefined) {
        if (company.company_id === company_id) {
          setIsUserAdminOfCompany(true);
          return;
        }
      } else if (company_name !== undefined) {
        if (company.name === company_name) {
          setIsUserAdminOfCompany(true);
          return;
        }
      }
    }
    setIsUserAdminOfCompany(false);
  }, [company_id, company_name, userContext.user]);

  return isUserAdminOfCompany;
};

export default useUserHasAdminAccessToCompany;
